import { Button } from "antd";
import React from "react";
import { useTranslation } from "react-i18next";
import { ReportTypeEnum } from "../../../../../constants/constants";
import { DATE_UTIL } from "../../../../../utils/dateUtils";
import { ECapReportStepProps } from "../../new-report";
import OutPutTable from "../output-table";

function BROutPut(props: ECapReportStepProps) {

    const { t } = useTranslation();

    const next = () => {
        if (props.next) {
            props.next();
        }
    }

    return (props.brOutput && props.brOutput.length) ? <div className="section-wrapper">
        <div className="result-title">
            <h4>
                {t("RapmReport.lbOutputData")}
            </h4>
            {
                props.next && <span style={{ color: "#646464" }}>
                    {DATE_UTIL.convertServerToViewDateTimeFormat(props.created_on)}
                </span>
            }

        </div>

        <div className="table-wrapper">
            {
                !props.next && <p>
                    {DATE_UTIL.convertServerToViewDateTimeFormat(props.created_on)}
                </p>
            }
            <OutPutTable
                data={props.brOutput}
                type={ReportTypeEnum.BusinessRisk}
            />
        </div>

        {
            props.next &&
            <div className="action">
                <Button htmlType="submit" type="primary" shape="round" onClick={next}>
                    {
                        t("RapmReport.btnSubmit")
                    }
                </Button>
            </div>
        }
    </div> : <> </>
}

export default BROutPut;